import { ABTestExperimentConfig } from '@jusbrasil-web/shared-ab-test'
import { SD_DOCVIEW_CHATS_EXPERIMENT_NAME } from '@jusbrasil-web/shared-seus-direitos'

export const DEFAULT_EXPERIMENTS = [
  {
    experimentGroup: 'docview',
    experimentName: 'seus-direitos-sofia-2',
    controlKey: 'control',
  },
  {
    experimentGroup: 'docview',
    experimentName: SD_DOCVIEW_CHATS_EXPERIMENT_NAME,
    controlKey: 'control',
  },
]

export const getActiveExperiments = (): ABTestExperimentConfig[] => {
  return DEFAULT_EXPERIMENTS
}
